// @flow
import * as React from 'react';

import { descriptorsLibrary } from 'Client/cms/toolkit/descriptors';
import { ErrorBoundary } from 'Context/ErrorBoundary';

type SubProps = *;
// This is a pretty ugly set of props. As explained in the component, there are multiple ways to
// call this component. Its API is hard to understand to make it somehow "generic". It should
// ideally be split. Please don't use directly in another component
export type LineProps = {
  id?: number,
  name?: string,
  component?: React.ComponentType<*>,
  props: SubProps,
};

export function Line({ id, component, name, props: { lines = [], ...props } }: LineProps) {
  // A Line can have nested lines. The root Line, the one in `DynamicPage.jsx` doesn't match to a
  // component, the component is just used for the recursion
  const Component =
    // When coming from the standard lines process (formatLinesForLineComponent of DynamicPage)
    // there is not component wired to a line, we retrieve the corresponding component from its name
    // But some lines (editorialFoldingBlock for instance) directly render lines themselves, and
    // pass a component prop, which then takes priority
    component || (descriptorsLibrary[name] && descriptorsLibrary[name].component) || null;
  if (Component) {
    return (
      <ErrorBoundary key={id}>
        <Component {...props} lines={lines}>
          {lines.map(Line)}
        </Component>
      </ErrorBoundary>
    );
  }
  return lines.length > 0 ? (
    <div className="Line-container" key={id}>
      {lines.map(Line)}
    </div>
  ) : null;
}
